export default __webpack_public_path__ + "static/media/Alaska-Airlines-Logo-b.3f6bd0db.png";